import { render } from "./icon-cockroach.vue?vue&type=template&id=de7b54b8&ts=true"
import script from "./icon-cockroach.vue?vue&type=script&lang=ts"
export * from "./icon-cockroach.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\project\\haocai\\h5\\kousai-group\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__